import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/esm/Col';

function OrganizerUsersCard({
  user,
  chosenOrganizerUser,
  onInactivate,
  onActivate,
  onEdit,
}) {
  return (
    <Card>
      <Card.Body>
        <Col
          className={
            user?.isActive
              ? 'd-flex flex-column'
              : 'd-flex flex-column inactive-tr'
          }
        >
          <div className='d-flex align-items-center justify-content-between'>
            <span className={user?.isActive ? 'text-secondary' : 'inactive-tr'}>
              Namn
            </span>
            <span>{user?.name}</span>
          </div>
          <div className='d-flex align-items-center justify-content-between pt-2'>
            <span className={user?.isActive ? 'text-secondary' : 'inactive-tr'}>
              E-post
            </span>
            <span>{user?.email}</span>
          </div>
          <div className='d-flex align-items-center justify-content-between pt-2'>
            <span className={user?.isActive ? 'text-secondary' : 'inactive-tr'}>
              Senast inloggad
            </span>
            {user?.loggedInDate.charAt(0) === '0' ? (
              <span>-</span>
            ) : (
              <span>{user?.loggedInDate.split('T')[0]}</span>
            )}
          </div>
        </Col>

        <Card.Footer className='mt-2'>
          <div className='d-flex gap-5 align-items-center justify-content-between'>
            {user.isActive ? (
              <div
                className='d-flex gap-2 justify-content-end'
                role='button'
                onClick={() => {
                  chosenOrganizerUser(user);
                  onInactivate();
                }}
              >
                <span className='material-symbols-outlined'>
                  do_not_disturb_on
                </span>
                <span>Inaktivera</span>
              </div>
            ) : (
              <div
                className='d-flex gap-2 justify-content-end'
                role='button'
                onClick={() => {
                  chosenOrganizerUser(user);
                  onActivate();
                }}
              >
                <span className='material-symbols-outlined'>add_circle</span>
                <span>Aktivera</span>
              </div>
            )}
            <Button
              variant='outline-primary'
              className='d-flex align-items-center'
              disabled={!user.isActive}
              onClick={() => {
                chosenOrganizerUser(user);
                onEdit();
              }}
            >
              <span
                className='material-symbols-outlined me-2'
                style={{ fontSize: '18px' }}
              >
                edit
              </span>
              Redigera
            </Button>
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default OrganizerUsersCard;
